import { useTheme } from '@mui/material';

export function useFormFieldAdornmentStyles(active?: boolean) {
  const theme = useTheme();

  return {
    color: theme.palette.primary.main,
    backgroundColor: active ? '#6BAA0033 !important' : 'transparent !important',
    p: 1,
    marginLeft: 0,
    width: 'auto',
    height: 'auto',
    borderRadius: '0 4px 4px 0px',
    zIndex: 100,
    '& svg': {
      fontSize: '1.25rem',
    },
  };
}
